import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=20923956"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=20923956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../repos/mylovelyladyhere.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports